import { API_V2 } from "@/config/api";

export const routes = {
  list: `${API_V2}/accounts`,
  get: (id: string) => `${API_V2}/accounts/${id}`,
};
